import { useMutation } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

import { getCampaigns } from '@/api/campaigns/get-campaigns'
import { Card, CardContent } from '@/components/ui/card'
import { env } from '@/env'

import { GetCampaigns } from '../types'

export function ParticipatingCampaigns() {
  const [campanhas, setCampanhas] = useState<GetCampaigns[]>([])

  const { mutate } = useMutation({
    mutationFn: getCampaigns,
    onSuccess: (data) => {
      setCampanhas(data) // aqui pode filtrar se necessário
    },
  })

  useEffect(() => {
    mutate()
  }, [])

  return (
    <div className="space-y-4 p-6">
      <h1 className="text-2xl font-bold">
        Histórico de Campanhas que Participei
      </h1>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-5">
        {campanhas.map((campanha) => (
          <Card key={campanha.campanha.id}>
            <img
              src={`${env.VITE_API_URL}${campanha.campanha.imagem}`}
              alt={campanha.campanha.titulo}
            />
            <CardContent>
              <h2 className="font-semibold">{campanha.campanha.titulo}</h2>
              <p className="text-sm">{campanha.campanha.descricao}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}
